<template>
  <div class="card card-1 no-border border-radius-5px m-b-30">
     <div class="card-body">
       <div v-if="draft.isArchived == 'Yes'" class="m-b-20 text-danger">
         <i  class="fa fa-lock" aria-hidden="true"></i> Archived
       </div>

       <a href="#" @click.prevent="accessNote(draft.id, 'Draft', draft.customerInfo.orderNo)" title="Order Notes" class="notes-link" :class="{active: draft.UserNotes.length }">
          <b-icon icon="layout-text-sidebar-reverse"></b-icon> {{ draft.UserNotes.length }}

        </a>

       <b-row>
         <b-col cols="4">
           <h3 class="m-b-20 orderNoHeading">Order no: <span class="orderNo">{{ orderPrefix }}{{ draft.customerInfo ? draft.customerInfo.orderNo : '' }}</span> 
            
           </h3>
         </b-col>
         <b-col cols="5">
           <timer v-if="needRevisionOnDraft" :deadline="moment(draft.customerRespondedOnDraftLinkAt).utc().add(1, 'days').toISOString()"/>
         </b-col>
         <b-col cols="3">
             <b-dropdown dropleft variant="dark"  id="dropdown-grouped"  text="Actions" class="float-right">
                <b-dropdown-group id="dropdown-group-1" header="Parent Order Actions">
                  
                  <b-dropdown-item-button @click="accessDraft(draft.customerInfo.orderNo, draft.order.id)">
                     Access Draft Widget
                  </b-dropdown-item-button>
                </b-dropdown-group>
                <b-dropdown-group id="dropdown-group-2" header="Draft Action">
                  <b-dropdown-item-button
                  @click="archiveUnarchiveDraft(draft.isArchived == 'Yes' ? 'No' : 'Yes')"
                  >{{ draft.isArchived == 'Yes' ? 'Unarchive' : 'Archive' }} this response</b-dropdown-item-button>
                </b-dropdown-group>

                <b-dropdown-divider></b-dropdown-divider>

                <b-dropdown-item-button
                  @click="setUnsetExtraStatus(draft.order.id, sendForPrintStatusId, isSendForPrintActive ? 'remove' : 'add')"
                  >{{ isSendForPrintActive ? 'Unset' : 'Set' }} "Send for Print"</b-dropdown-item-button>


              </b-dropdown>
              
         </b-col>
       </b-row>

       <div class="m-b-20">
         Parent Order has :<draft-order-active-extra-status v-for="extraStatus in draft.order.extraStatus" :key="extraStatus.id" :extra-status="extraStatus"/>
       </div>
      
       <b-list-group class="m-b-25">
          <b-list-group-item class="text-warning"><strong>Draft Sent at:</strong> UTC: {{  draft.createdAt ? moment(draft.createdAt).utc().format('DD-MM-YYYY, h:mm a') : '' }}  | YOUR LOCAL: {{  draft.createdAt ? moment(draft.createdAt).format('DD-MM-YYYY, h:mm a') : '' }} </b-list-group-item>
          <b-list-group-item><strong>Customer Name:</strong> {{ draft.customerInfo ? draft.customerInfo.firstName : '' }} {{ draft.customerInfo ? draft.customerInfo.lastName : '' }}</b-list-group-item>
          <b-list-group-item><strong>Customer Email:</strong> {{ draft.customerInfo ? draft.customerInfo.email : '' }}</b-list-group-item>
          <b-list-group-item><strong>Customer Mobile:</strong> {{ draft.customerInfo ? draft.customerInfo.phone : '' }}</b-list-group-item>
          <b-list-group-item><strong>Country:</strong> {{  draft.customerInfo ? draft.customerInfo.country_name : '' }}</b-list-group-item>
          <b-list-group-item><strong>Draft Hash:</strong> {{  draft.draftPageHash ? draft.draftPageHash : '' }}</b-list-group-item>
          <b-list-group-item><strong>Customer Revision time limit:</strong> {{  draft.draftRevisionDateTimeLimit ? moment(draft.draftRevisionDateTimeLimit).utc().format('DD-MM-YYYY, h:mm a') : '' }} UTC</b-list-group-item>
          <b-list-group-item class="text-info"><strong>Customer Responded at:</strong> {{  draft.customerRespondedOnDraftLinkAt ? moment(draft.customerRespondedOnDraftLinkAt).utc().format('DD-MM-YYYY, h:mm a') : '' }} UTC</b-list-group-item>
          <b-list-group-item><strong>Review Time status:</strong>  {{  draft.draftRevisionDateTimeLimit ? (moment(draft.draftRevisionDateTimeLimit).utc() < moment().utc()) ? "Review time is over. You can proceed" : 'Review time not over' : '' }}</b-list-group-item>
          <b-list-group-item v-if="draft.DraftFeedback && draft.DraftFeedback.rating"><strong>Customer Rated Work as :</strong> <star-rating :inline="true" class="star-rating" :increment="0.5" :star-size="20" :read-only="true"  :rating="parseFloat(draft.DraftFeedback.rating)"></star-rating>  </b-list-group-item>
          <b-list-group-item v-if="draft.DraftFeedback"><strong>Customer Satisfaction :</strong>  {{ draft.DraftFeedback.designSatisfaction }} </b-list-group-item>
          <b-list-group-item v-if="draft.DraftFeedback"><strong>Customer Feedback Comment :</strong>  {{ draft.DraftFeedback.comment }} </b-list-group-item>
        </b-list-group>
        <h4>Draft Files</h4>
        <section>
           <single-draft-with-issue-file v-for="draftFile in draft.DraftFiles" :key="draftFile.id" :draft-file="draftFile" />
        </section>

     </div>
     
  </div>
</template>

<script>
const SingleDraftWithIssueFile = () => import(/* webpackChunkName: "single-draft-with-issue-file" */ './single-draft-with-issue-file')
import StarRating from 'vue-star-rating';
const DraftOrderActiveExtraStatus = () => import(/* webpackChunkName: "draft-order-active-extra-status" */ "./draft-order-active-extra-status")
const Timer = () => import(/* webpackChunkName: "comp.timer" */ "../../../components/common/timer")
import ExtraStatusesMixin from '../../orders/partials/extra-statuses.mixin'
import CustomerDraftsService from '../../../services/customer-drafts.service'
import EventBus from '../../../EventBus';
  export default {
     data(){
       return {
         inProgress: false
       }
     },
     mixins: [ExtraStatusesMixin],
     props: {
       draft: {
         type: Object,
         default: () => ({})
       },
       orderPrefix: {
         type: String,
         default: ''
       },
       sendForPrintStatusId:{
         type: Number,
         default: null
       }
     },
     components: {SingleDraftWithIssueFile, StarRating, DraftOrderActiveExtraStatus, Timer},
     methods: {
       accessNote(recordId, noteType, orderNo = "") {
          EventBus.$emit("access-notes", { recordId, noteType, orderNo });
        },
       accessDraft(orderNo, orderId) {
          
          EventBus.$emit("accessed-customer-draft", { orderNo, orderId });
        },
       async archiveUnarchiveDraft(archiveValue){

          let that = this;
          this.$dialog
          .confirm('Please confirm your action')
          .then(async function(dialog) {


         try{
            that.inProgress = true;
            const result = await CustomerDraftsService.archiveUnarchiveDraft({id: that.draft.id, archiveValue})


                that.$toasted.show(
                  result.data.message,
                  {
                    action: {
                      text: "Close",
                      class: "toastBtnTxt",
                      onClick: (e, toastObject) => {
                        toastObject.goAway(0);
                      },
                    },
                    duration: 2000,
                  }
                );

                EventBus.$emit('archived-status-updated-on-draft-response')

                that.inProgress = false;
              }catch(e){
                console.log(e)
                that.inProgress = false;

              }

          })
          .catch(function() {
            console.log('Clicked on cancel');
          });

         
       }
     },
     computed: {
       isSendForPrintActive(){
          if(this.draft){
              for(let status of this.draft.order.extraStatus){
                if(status.name == 'Send for Print'){
                   return true;
                   break;
                }
              }
          }
          return false;
       },
       needRevisionOnDraft(){
         return this.draft.DraftFiles.find(file => file.approvalStatus == 'No') ? true : false;
       }
     }
  }
</script>

<style lang="scss" scoped>
  .orderNo{
    border: 2px solid red;
    color:red;
    display: inline-block;
    padding: 5px 10px;
    border-radius: 5px;
  }
  .orderNoHeading{
    div{
      font-size: 15px;
      display: inline-block;
      margin-left: 20px;
      color: rgb(28, 201, 66);
    }
  }

  .notes-link {
  text-decoration: none;
  position: absolute;
  left: -40px;
  width: 40px;
  z-index: 1;
  font-size: 13px;
  display: inline-block;
  background-color: rgb(233, 233, 233);
  color: rgb(107, 107, 107);
  padding: 5px;
  top: 35px;
  border-radius: 5px 0 0 5px;
  &.active {
    background-color: rgb(236, 28, 108);
    color: #fff;
  }
}
.star-rating{
  position: relative;
  top: -3px;
}
</style>